import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  notAvailableText: {
    id: 'product.item.unavailable.label',
    defaultMessage: 'Nedostupné',
  },
  disabledProductText: {
    id: 'product.item.disabled.label',
    defaultMessage: 'Prodej byl ukončen',
  },
});
